<ng-container *ngIf="!soloValores">
    <form class="mt-1" #formInsumo="ngForm">

        <plex-select [(ngModel)]="insumo.diagnostico" hintType="info" label="Diagnóstico / Procedimiento"
            [data]="registros" name="diagnostico" multiline="true" [required]="true" labelField="term"
            idField="conceptId" hint="Se listaran los conceptos registrados en esta consulta" hintType="info"
            hintIcon="eye">
        </plex-select>

        <plex-grid cols="2">
            <plex-select [(ngModel)]="insumo.generico" name="generico" (getData)="loadInsumo($event)"
                placeholder="Insumo genérico" label="Insumo" idField="id" labelField="nombre" required="true"
                (change)="requiereEspecificacion()">
            </plex-select>

            <plex-int class="formEditar" [ngClass]="{ 'w-100': !unidades.length }" name="comprimidos" label="Cantidad"
                [(ngModel)]="insumo.cantidad" required="true" min="1" max="90">
            </plex-int>
        </plex-grid>
        <plex-text *ngIf="mostrarEspecificacion" name="especificacion" label="Especificación Médica"
            [(ngModel)]="insumo.especificacion" required="mostrarEspecificacion" min="1" max="90">
        </plex-text>

        <plex-grid cols="2" class="grid-tratamiento mt-2">
            <plex-bool [(ngModel)]="insumo.tratamientoProlongado" name="tratamientoProlongado" type="slide"
                label="Tratamiento prolongado">
            </plex-bool>
            <plex-select *ngIf="insumo.tratamientoProlongado" [(ngModel)]="insumo.tiempoTratamiento"
                name="tiempoTratamiento" [data]="tiemposTratamiento" required="true">
            </plex-select>
        </plex-grid>

        <hr>

        <div class="d-flex justify-content-center">
            <plex-button name="botonAgregar" type="info" [disabled]="!formInsumo.valid || verificandoDuplicado" (click)="preAgregarInsumo($event)"
                [validateForm]="formInsumo">
                Agregar
            </plex-button>
        </div>
    </form>

    <div *ngIf="!registro.valor.insumos.length" class="lista-vacia">
        <plex-label icon="frasco" type="default" size="md" direction="column" titulo='Aún no hay insumos
                    agregados' subtitulo=''>
        </plex-label>
    </div>

    <plex-list size="md" *ngIf="registro.valor.insumos" class="mt-3">
        <plex-item *ngFor="let item of registro.valor.insumos">
            <plex-icon size="md" *ngIf="true" name="frasco" class="icon icon--border--producto mr-2">
            </plex-icon>
            <plex-label [tituloBold]="true" titulo="{{ item.generico.nombre | capitalizeFirst }}"
                subtitulo="Cantidad: {{ item.cantidad}} {{ item.especificacion? '| ' + item.especificacion : ' ' }}">
            </plex-label>
            <plex-badge *ngIf="item.diagnostico" size="sm" type="warning" hintType="warning">
                {{ item.diagnostico.term | truncate }}
            </plex-badge>
            <plex-badge *ngIf="item.tratamientoProlongado" type="info">Tratamiento prolongado
            </plex-badge>
            <plex-button type="danger" size="sm" (click)="borrar(item)" icon="delete" tooltip="eliminar"></plex-button>
        </plex-item>
    </plex-list>
</ng-container>

<div *ngIf="soloValores">
    <div *ngIf="soloValores && alerta" class="alerta">{{alerta}}</div>
    <plex-list size="md" *ngIf="registro.valor.insumos" [selectable]="false">
        <plex-item *ngFor="let item of registro.valor.insumos">
            <plex-label [tituloBold]="true" titulo="{{ item.generico.nombre | capitalizeFirst }}"
                subtitulo="Cantidad: {{ item.cantidad}} {{ item.especificacion? '| ' + item.especificacion : ' ' }}">
            </plex-label>
            <plex-badge *ngIf="item.diagnostico" size="sm" type="warning" hintType="warning">
                {{ item.diagnostico.term | truncate }}
            </plex-badge>
            <plex-badge *ngIf="item.tratamientoProlongado" type="info">Tratamiento prolongado
            </plex-badge>
        </plex-item>
    </plex-list>
</div>